import { Grid } from "@mui/material";
import CheckOutAssetDialog from "../../../dialogs/asset/CheckOutEquipmentDialog";
import EditAssetDialog from "../../../dialogs/asset/EditAssetDialog";
import { ModalType, modalTypes, CheckOutAsset, EditAsset } from "../data";
import { InventoryReportViewVO } from '../../../../types/model/valueObject/InventoryReportViewVO';
import {useSnackbar} from "../../../../context/snackbar-context";

interface DialogWrapperProps {
    openDialog: ModalType;
    assetBeingActioned: InventoryReportViewVO | null;
    onCloseDialogs: () => void;
    onCheckOutAsset: (asset: CheckOutAsset) => any;
    onEditAsset: (asset: EditAsset) => any;
    account: {loggedInUsername: string},
    setImageDropZone: (item: any) => void;
    checkOutLoading?: boolean;
}

const SupplierCurrentInventoryDialogs = (props: DialogWrapperProps) => {
    const {openDialog, assetBeingActioned, onCloseDialogs, onCheckOutAsset, onEditAsset, account, setImageDropZone, checkOutLoading} = props;
    const { snackbarShowMessage } = useSnackbar();

    const determineOpenDialog = (dialogName: string) => {
        return openDialog.type === dialogName && openDialog.open;
    };

    return <Grid>
        <CheckOutAssetDialog
            open={determineOpenDialog(modalTypes.CHECKOUT)}
            asset={assetBeingActioned}
            onClose={onCloseDialogs}
            handleCheckout={onCheckOutAsset}
            setImageDropZone={setImageDropZone}
            account={account}
            snackbarShowMessage={snackbarShowMessage}
            loading={checkOutLoading}
        />
        <EditAssetDialog
            open={determineOpenDialog(modalTypes.EDIT)}
            asset={assetBeingActioned}
            onClose={onCloseDialogs}
            handleEdit={onEditAsset}
            account={account}
            snackbarShowMessage={snackbarShowMessage}
        />
    </Grid>
}

export default SupplierCurrentInventoryDialogs
